import React from 'react';

interface AgreementCheckbox {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  /** If true the checkbox is auto-derived (disabled, no click handler) */
  readOnly?: boolean;
}

interface AgreementCheckboxesProps {
  checkboxes: AgreementCheckbox[];
}

/**
 * A stack of styled agreement / acknowledgement checkboxes.
 * Extracted from ReviewSign so other steps can reuse the same pattern.
 */
const AgreementCheckboxes: React.FC<AgreementCheckboxesProps> = ({ checkboxes }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
    {checkboxes.map((cb) => (
      <div
        key={cb.id}
        onClick={cb.readOnly ? undefined : () => cb.onChange(!cb.checked)}
        data-testid={`${cb.id}-checkbox`}
        style={{
          display: 'flex', alignItems: 'flex-start', gap: 14,
          padding: '14px 18px',
          background: cb.checked ? '#F0F7FF' : (cb.readOnly ? '#F8FAFC' : '#fff'),
          border: `1px solid ${cb.checked ? '#0F2647' : '#E2E8F0'}`,
          borderRadius: 10,
          cursor: cb.readOnly ? 'default' : 'pointer',
          transition: 'all 0.2s ease',
          opacity: cb.readOnly && !cb.checked ? 0.6 : 1,
          pointerEvents: cb.readOnly ? 'none' : undefined,
        }}
      >
        <input
          type="checkbox"
          id={cb.id}
          checked={cb.checked}
          onChange={cb.readOnly ? undefined : (e) => cb.onChange(e.target.checked)}
          disabled={cb.readOnly}
          style={{
            width: 20, height: 20, marginTop: 1,
            cursor: cb.readOnly ? 'default' : 'pointer',
            accentColor: '#0F2647', flexShrink: 0,
          }}
        />
        <label
          htmlFor={cb.readOnly ? undefined : cb.id}
          style={{
            flex: 1, cursor: cb.readOnly ? 'default' : 'pointer',
            fontSize: 13, lineHeight: 1.6, color: '#1E293B',
          }}
        >
          {cb.label}
        </label>
      </div>
    ))}
  </div>
);

export default AgreementCheckboxes;
